import { render, staticRenderFns } from "./PlanogramPage.vue?vue&type=template&id=99ab8bac&scoped=true"
import script from "./PlanogramPage.vue?vue&type=script&lang=js"
export * from "./PlanogramPage.vue?vue&type=script&lang=js"
import style0 from "./PlanogramPage.vue?vue&type=style&index=0&id=99ab8bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ab8bac",
  null
  
)

export default component.exports